import React, { useRef } from "react";
import cs from "classnames";
import { debounce } from "lodash";
import { useHistory } from "react-router-dom";
import { useCartContext } from "../../../lib/context/CartContext/CartContext";
import "./UserCart.scss";
import { Icon } from "../../../components/shared/Icon/Icon";

interface Props {
  className?: string;
}
export const UserCart = (props: Props) => {
  const ref = useRef<any>(null);
  const cartCtx = useCartContext();
  const history = useHistory();

  const onMouseEnter = debounce(() => {
    if (!cartCtx.isEmpty) {
      cartCtx.setCartUiState({ ...cartCtx.cartUiState, open: true });
      if (ref && ref.current) {
        ref.current.setAttribute("force-open", true);
      }
    }
  }, 300);

  const onMouseLeave = debounce(() => {
    if (!cartCtx.isEmpty) {
      cartCtx.setCartUiState({
        ...cartCtx.cartUiState,
        open: false,
      });
      if (ref && ref.current) {
        ref.current.removeAttribute("force-open");
      }
    }
  }, 300);

  const count = cartCtx?.items?.length;

  return (
    <span ref={ref}>
      <span
        role="button"
        onClick={() => history.push("/my-cart")}
        id="user-cart"
        className={cs("UserCart", props.className)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span className="UNavigation__item--wishlist-icon">
          {/* <ShoppingCart width={24} height={24} /> */}
          <Icon icon="cart" />
          {count && count > 0 ? (
            <div className="UNavigation__item--wishlist-icon-number">
              {count}
            </div>
          ) : null}
        </span>
        {/* <span className="UNavigation__item__label"> Shporta</span> */}
      </span>
    </span>
  );
};
